var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-list-item',{attrs:{"to":"/cache"}},[_c('v-icon',{staticClass:"mr-3"},[_vm._v(" $manageCache ")]),_c('span',[_vm._v(" "+_vm._s(_vm.$t('base.cache.title'))+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }